import { SnackbarProvider } from "notistack";
import React from "react";
import { Toast } from "components/Toast";
import { EventLinkRouting } from "./EventLinkRouting";
import { Fonts, FontFamilies } from "theme/fontConfig";

export const EventLink = () => {
  return (
    <>
      <SnackbarProvider
        maxSnack={1}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={4000}
        style={{ fontFamily: FontFamilies.General, fontSize: Fonts.GeneralLargeBodyFont.fontSize }}
      >
        <EventLinkRouting />
      </SnackbarProvider>
      <Toast />
    </>
  );
};
